import { render, staticRenderFns } from "./StudentScholarshipEdit.vue?vue&type=template&id=b45913f2"
import script from "./StudentScholarshipEdit.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipEdit.vue?vue&type=style&index=0&id=b45913f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports